module.exports = __webpack_public_path__ + "static/media/tournament-min.b745d087.jpg";